<template>
  <v-layout column pa-4>
    <v-flex xs4>
      <h1>Testimonials types</h1>
      <v-dialog persistent v-model="modalWindow" max-width="800px">
        <v-btn color="primary" slot="activator" dark class="my-3" @click="addTestimonialsType">Add Type</v-btn>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>
          <v-flex px-4>
            <h3>Type name:</h3>
            <content-editor label="Name"
              @blur="$v.formData.name.$touch()"
              :error="$v.formData.name"
              v-model="formData.name"
            />
          </v-flex>
            <v-card-actions>
                <v-spacer/>
                <v-btn color="blue darken-1" flat @click.stop="closeFormForTestimonialTypes">Cancel</v-btn>
                <v-btn color="blue darken-1" flat @click.stop="saveTestimonialTypes">Save</v-btn>
              </v-card-actions>
        </v-card>
      </v-dialog>
      <v-card width="400">
        <v-layout justify-space-between pa-2 row v-for="(item, index) in testimonialTypesList" :key="index">
          <v-flex class="pa-3"><strong v-html="item.name"></strong></v-flex>
          <v-btn flat icon color="success" @click.stop="editTestimonialType(item)">
            <v-icon>edit</v-icon>
          </v-btn>
          <v-btn flat icon color="error" @click.stop="removeTestimonialType(item.id)">
            <v-icon>delete</v-icon>
          </v-btn>
        </v-layout>
      </v-card>
    </v-flex>
    <v-dialog persistent width="500" v-model="modalChangeTypeForDelete">
      <v-card v-if="path(['id'], removeType)">
        <v-card-title>
          <h3 class="red--text">Type related to testimonials!!</h3>
        </v-card-title>
        <v-card-text>
          <strong>Choose other type:</strong>
          <v-select
              :items="listTestimonialsTypesWithoutRemove"
              item-value="id"
              item-text="name"
              v-model="removeType.replacementTypeId"
            ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click.stop="chengeTypeForRelatedTestimonials">Change type</v-btn>
          <v-btn color="error" @click.stop="removeTestimonialTypeAndHisTestimonials">Remove type and his testimonials</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import { required } from 'vuelidate/lib/validators'
import { mapActions, mapGetters } from 'vuex'
import { clone, isEmpty, omit, propEq, filter, map, path } from 'ramda'

export default {
  name: 'TestimonialsTypes',
  data () {
    return {
      modalWindow: false,
      modalChangeTypeForDelete: false,
      isNewType: true,
      removeType: {
        id: '',
        replacementTypeId: null
      },
      formData: {
        name: ''
      }
    }
  },
  validations: {
    formData: {
      name: { required }
    }
  },
  computed: {
    ...mapGetters([
      'testimonialTypesList'
    ]),
    formTitle () {
      return this.isNewType ? 'New Type' : 'Edit Type'
    },
    listTestimonialsTypesWithoutRemove() {
      return this.testimonialTypesList
        ? this.testimonialTypesList.filter((type) => type.id !== this.removeType.id)
        : []
    }
  },
  methods: {
    ...mapActions([
      'fetchTestimonialTypes',
      'addTestimonialTypes',
      'updateTestimonialTypes',
      'removeTestimonialTypes',
      'fetchlastYearTestimonialsByType'
    ]),
    path,
    addTestimonialsType () {
      this.isNewType = true
    },
    closeFormForTestimonialTypes () {
      this.modalWindow = false
      this.formData = clone({ name: '' })
    },
    async saveTestimonialTypes () {
      this.$v.formData.$touch()
      if (this.$v.formData.$invalid) return
      if (this.isNewType) {
        try {
          await this.addTestimonialTypes(this.formData)
          this.closeFormForTestimonialTypes()
          await this.getTestimonialTypes()
        } catch (err) {
          throw err
        }
      } else {
        try {
          await this.updateTestimonialTypes(this.formData)
          this.closeFormForTestimonialTypes()
          await this.getTestimonialTypes()
        } catch (err) {
          throw err
        }
      }
    },
    editTestimonialType (type) {
      this.modalWindow = true
      this.isNewType = false
      this.formData = clone(type)
    },
    closeFormForChangeType () {
      this.modalChangeTypeForDelete = false
    },
    async chengeTypeForRelatedTestimonials () {
      try {
        await this.removeTestimonialTypes(this.removeType)
        this.closeFormForChangeType()
        this.getTestimonialTypes()
      } catch (err) {
        console.error(err)
      }
    },
    async removeTestimonialTypeAndHisTestimonials () {
      try {
        const payload = omit(['replacementTypeId'], this.removeType)
        await this.removeTestimonialTypes(payload)
      } catch (err) {
        console.error(err)
      }
    },
    async removeTestimonialType (typeId) {
      try {
        const lastYearTestimonialsByType = await this.fetchlastYearTestimonialsByType(typeId)
        this.removeType.id = typeId
        if (!isEmpty(lastYearTestimonialsByType.testimonials)) {
          this.modalChangeTypeForDelete = true
        } else {
          await this.removeTestimonialTypes(this.removeType)
        }
      } catch (err) {
        console.error(err)
      }
      this.getTestimonialTypes()
    },
    async getTestimonialTypes () {
      await this.fetchTestimonialTypes()
    }
  },
  mounted () {
    this.getTestimonialTypes()
  }
}
</script>




// WEBPACK FOOTER //
// src/components/pages/Testimonials/TestimonialsTypes/index.vue